/*
 * @Author: your name
 * @Date: 2021-09-16 11:19:39
 * @LastEditTime: 2021-12-09 09:34:40
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\api\passport\passportApi.js
 */
import { postFetch, getFetch } from '@/utils/request'
import Cookies from 'js-cookie'

// 登录
export function login(params) {
    return postFetch('/passport/login', null, params)
}

export function mobileLogin(mobile, msgCode) {
    return postFetch('/passport/mobileLogin', null, {mobile: mobile, smsCode: msgCode})
}

export function registerCustomer(account) {
    let sellerId = Cookies.get('sellerId');
    if (sellerId) {
        account.sellerId = sellerId;
    }
    return postFetch('/passport/register', null, account)
}

export function checkMobileOrLoginNameIsExistData(name) {
    return getFetch('/passport/checkMobileOrLoginNameIsExist', {name: name})
}

export function resetPasswordData(mobile, smsCode, password) {
    return postFetch('/passport/resetPassword', null, {mobile: mobile, smsCode: smsCode, password: password})
}

// 退出
export function logout(){
    return postFetch("/passport/logout", {})
}

export function checkIsLogin() {
    return getFetch('/passport/checkIsLogin', {})
}

// 手机号注册
export function mobileRegister(params) {
    let sellerId = Cookies.get('sellerId');
    if (sellerId) {
        params.sellerId = sellerId;
    }
    return postFetch('/passport/mobileRegister', null, params)
}



// WEBPACK FOOTER //
// ./src/api/passport/passportApi.js